const helpCenterEvent = "helpCenterPageChange";
const helpCenterChangedEvent = "helpCenterPageChanged";
const helpCenterBackEvent = "helpCenterBackEvent";
class HelpCenter extends HTMLElement {
  constructor() {
    super();
    this.SELECTORS = {
      content: "article.content",
    };
    this.content = this.querySelector(this.SELECTORS.content);
    this.links = this.querySelectorAll(".content-switch a, .mobile-return");
    this.links = [
      ...this.links,
      ...document.querySelectorAll("help-center-nav a"),
    ];
  }
  connectedCallback() {
    this.initLinks(this.links);
    document.addEventListener(helpCenterEvent, (e) => {
      const link = e.detail.link;
      if (!link) return;
      this.setActiveLink([link]);
      this.fetchData(link.href);
    });
    const hash = location.hash;
    hash && this.querySelector(decodeURI(hash)).expand(true);
    this.setActiveLink(this.getActive());
    this.classList.add("initialized");

    window.addEventListener("popstate", (e) => {
      if (e.state) {
        this.content.style.opacity = "0";
        document.title = e.state.pageTitle;
        this.setActiveLink(this.getActive());
        setTimeout(() => {
          this.content.innerHTML = e.state.html;
          this.content.style.opacity = "1";
          document.dispatchEvent(
            new CustomEvent(helpCenterChangedEvent, {
              detail: { pageTitle: e.state.title },
            })
          );
        }, 50);
      }
    });
    document.addEventListener(helpCenterChangedEvent, (e) => {
      this.initLinks(this.content.querySelectorAll(".mobile-return"));
    });
    window.history.replaceState(
      {
        html: this.content.innerHTML,
        pageTitle: document.title,
        title: this.querySelector("h1").innerText,
      },
      "",
      window.location
    );
  }
  disconnectedCallback() {}
  setActiveLink = (links) => {
    this.links.forEach((x) => x.classList.remove("active"));
    links?.length > 0 &&
      links.forEach((link) => {
        link?.classList.add("active");
      });
  };
  getActive = () => {
    const aObj = [...this.links];
    const activeLinks = [];
    for (let el of aObj) {
      if (document.location.href.indexOf(el.href) >= 0) {
        activeLinks.push(el);
      }
    }
    return activeLinks;
  };
  initLinks = (links) => {
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent(helpCenterEvent, { detail: { link: link } })
        );
        if (link.classList.contains("mobile-return"))
          document.dispatchEvent(new CustomEvent(helpCenterBackEvent, {}));
      });
    });
  };
  getHtml = async (data) => {
    if (data.status !== 200) throw new Error("Error fetching.");
    return new DOMParser().parseFromString(await data.text(), "text/html");
  };
  fetchData = async (url) => {
    this.content.style.opacity = "0";
    const data = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const html = await this.getHtml(data);
    this.content.innerHTML = "";
    const title = html.querySelector("h1").innerText;
    const content = html.querySelector(this.SELECTORS.content);
    window.history.pushState(
      {
        html: content.innerHTML,
        pageTitle: html.title,
        title: title,
      },
      "",
      url
    );
    this.content.append(...content.childNodes);
    this.content.style.opacity = "1";
    document.title = html.title;

    document.dispatchEvent(
      new CustomEvent(helpCenterChangedEvent, {
        detail: { pageTitle: title },
      })
    );
  };
}

customElements.define("help-center", HelpCenter);
class HelpCenterTitle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    document.addEventListener(helpCenterChangedEvent, (e) => {
      this.innerText = e.detail.pageTitle;
    });
    this.classList.add("initialized");
  }
  disconnectedCallback() {}
}
customElements.define("help-center-title", HelpCenterTitle);

class HelpCenterNav extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.closest("accordion-element");
  }
  connectedCallback() {
    this.classList.add("initialized");
    document.addEventListener(helpCenterBackEvent, () => {
      this.accordion.expand();
    });
  }
  disconnectedCallback() {}
}
customElements.define("help-center-nav", HelpCenterNav);
